import UserMessage from './message/UserMessage';
import AssistantMessage from './message/AssistantMessage';

interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  image?: string;
  imageId?: string;
  previewImage?: string;
  isGeneratingImage?: boolean;
  imageGenerationStartTime?: number;
  model?: string;
  userPrompt?: string;
  promptId?: string;
  rating?: 'thumbs_up' | 'thumbs_down' | null;
  error?: string;
  hasError?: boolean;
  style?: string; // Template ID used for this prompt
  templateUsed?: {
    id: string;
    title: string;
    icon?: string;
  };
}

interface MessageDisplayProps {
  sessionTitle?: string;
  message: Message;
  sessionId?: string;
  onRegenerate?: (model: string, prompt: string, promptId?: string, modelObject?: any) => void;
  allImageMessages?: Message[];
  currentImageIndex?: number;
}

export default function MessageDisplay({ message, sessionTitle, sessionId, onRegenerate, allImageMessages, currentImageIndex }: MessageDisplayProps) {
  if (message.role === 'user') {
    return <UserMessage content={message.content} style={message.style} templateUsed={message.templateUsed} />;
  }

  return <AssistantMessage 
    message={message} 
    sessionTitle={sessionTitle}
    sessionId={sessionId}
    onRegenerate={onRegenerate}
    allImageMessages={allImageMessages}
    currentImageIndex={currentImageIndex}
  />;
}